import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import _ from 'lodash'
import { messageActions } from '../../store/message'

const BASE_PATH = '/lottustech/lancamentosfinanceiros/'
const crud = build(validate, BASE_PATH)
const prefix = 'crudTransferenciaEntreContas'

const newTypes = {
  RESET: `${prefix}reset`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}
actions.transferir = () => {
  return (dispatch, getState) => {
    const state = getState()[`crudTransferenciaEntreContasState`]
    const params = _.get(state, 'currentRecord', {})
    const path = BASE_PATH + `/transferir`
    return apiService
      .post(path, params)
      .then((response) => {
        dispatch(messageActions.messageShowMessages(makeMessages(['Transferência criada com sucesso']), 'success'))
        dispatch(actions.reset())
      })
      .catch((error) => {
        if (error.response) {
          const messages = error.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages]), 'error'))
        }
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = ''
  if (type === 'error') {
    summary = ''
    sticky = true
  } else if (type === 'warn') {
    summary = ''
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}
export { types, actions }
